export default {
  data() {
    return {
      isMobile: true,
      isTablet: true,
      isGoogleBot: true,
    };
  },
  created() {
    this.isMobile = window.innerWidth < 639;
    this.isTablet = window.innerWidth < 999;
    if (!window.innerWidth) {
      this.isMobile = true;
      this.isTablet = true;
    }
  },
  mounted() {
    window.addEventListener('resize', this.calcWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcWidth);
  },
  methods: {
    calcWidth() {
      if (!window.innerWidth) {
        this.isMobile = true;
        this.isTablet = true;
      } else {
        this.isMobile = window.innerWidth < 639;
        this.isTablet = window.innerWidth < 999;
      }
    },
  },
};
